import { Box } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'
import { EmployeeForSelectFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import TooltipIcon from 'modules/shift_management/components/ShiftManagement//TooltipIcon'
import AddEmployeesNoticeBox from 'modules/shift_management/components/ShiftManagement/AddEmployeesNoticeBox'
import EmployeesSelector from 'modules/shift_management/components/ShiftManagement/EmployeesSelector'
import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import { useOnSelectEmployees } from 'modules/shift_management/hooks/useOnSelectEmployees'

interface ExtendedForm extends Form {
  employees?: EmployeeForSelectFragment[] | undefined
}

interface Props {
  form: ExtendedForm
  selectableEmployeeIds: number[]
  selectedEmployees: number[]
  setSelectedEmployees: (value: number[]) => void
}

const AssigneesSelector = ({
  form,
  selectableEmployeeIds,
  selectedEmployees,
  setSelectedEmployees,
}: Props) => {
  const [{ hasFeatureFlag }] = useEnabledFeatures()
  const newEmployeesSelector = hasFeatureFlag('dev_shift_management_new_employees_selector')

  const errors = form.get('employee_id')?.errors ?? []
  const error = errors[0] ?? undefined
  const { onSelectEmployee } = useOnSelectEmployees({
    form,
    selectedEmployees,
    setSelectedEmployees,
  })

  return (
    <>
      <Box
        className={error && 'error-anchor'}
        flexDirection="row"
        gap="s16"
        justifyContent="center"
        alignItems="center"
      >
        <TooltipIcon.Medium
          icon="person"
          label={i18n.t('shift_management.actions_sidepanel.tooltip.assignee')}
          color="grey700"
        />
        {/* Send error once we migrate to the new EmployeeSelector using GraphQL */}
        <EmployeesSelector
          field={form.get('employee_id')}
          hideLabel
          selectableEmployeeIds={selectableEmployeeIds}
          onSelectEmployee={onSelectEmployee}
          selectedEmployeeIds={selectedEmployees}
          width={newEmployeesSelector ? 's300' : 's360'}
        />
      </Box>
      <AddEmployeesNoticeBox newVersion />
    </>
  )
}

export default observer(AssigneesSelector)
